import {useEffect,useState} from 'react';
import {useDocumentIntakeContext} from '../document-intake-context';
import {Link} from '../ui/ScopedLink';

type Context={text:string;messageId?:string;threadId?:string;subject?:string|null};
/** Desktop review: keep the original email explanation beside the attachment, including unpreviewable media. */
export function DocumentSourceContext({itemId}:{itemId:string}){
 const {api,building}=useDocumentIntakeContext();
 const [context,setContext]=useState<Context|null>(),[error,setError]=useState(false),[retry,setRetry]=useState(0);
 useEffect(()=>{let active=true;setContext(undefined);setError(false);
  void api<{context:Context|null}>(`/api/document-ingestion/items/${itemId}/source-context`).then(result=>{if(active)setContext(result.context)}).catch(()=>{if(active)setError(true)});
  return()=>{active=false;};
 },[itemId,building,retry]);
 if(error)return <p>Source context could not be loaded. <button className="link-button" onClick={()=>setRetry(n=>n+1)}>Retry</button></p>;
 if(!context?.messageId)return null;
 return <section aria-label="Source email"><h3>Source email</h3><p>{context.subject}</p>
  <details open><summary>Email explanation</summary><p style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{context.text}</p></details>
  <p>This is the sender’s explanation, not confirmation that the attachment’s contents have been independently checked.</p>
  {context.threadId&&<Link to={`/communications/threads/${context.threadId}`}>Open source conversation</Link>}
 </section>;
}
